import React from 'react'
import logo from '../assets/logo/Logo-Pro-Lex-IT.png'
export default function Logo() {
  return (
    <div className='logo'>
        <img src={logo} alt="Logo" className='logo-img'/>
    </div>
  )
}
